Core.OrdersRouter = Core.SubRouter.extend({
    routes: {

        'new': 'newOrder',
        ':id/edit': 'editOrder',
        ':id/copy': 'copyOrder',
        ':id': 'viewOrder',
        'orderdetails': 'orderdetails',

        '': 'orders',
        'all': 'all',
        'mine': 'mine',
        'pending': 'pending',
        'templates': 'templates'
    },

    newOrder: function () {
        debug.log('new order');
        var view = new OrderDetailsView({
            sharedView: typeof Core.param('shared') != 'undefined',
            customerView: typeof Core.param('customer') != 'undefined' && isNaN(parseInt(Core.param('customer')))
        });
        if (Core.param('returnTo')) view.saveAction = Core.param('returnTo');

        view.editing = true;
        view.setModel(new JobOrder({creatorId: Core.client.me.id}));
        app.setMainView(view, Core.param('template') != undefined ? 'directory' : 'orders');
    },

    editOrder: function (id) {
        debug.log('edit order', id);
        var view = new OrderDetailsView({
            sharedView: typeof Core.param('shared') != 'undefined',
            customerView: typeof Core.param('customer') != 'undefined' && isNaN(parseInt(Core.param('customer')))
        });
        if (Core.param('returnTo')) view.saveAction = Core.param('returnTo');

        view.editing = true;
        if (view.model.id != id) view.setModel(new JobOrder({id: id}));
        else view.change();
        app.setMainView(view, Core.param('template') != undefined ? 'directory' : 'orders');
    },

    viewOrder: function (id) {
        debug.log('view order', id);
        var view = new OrderDetailsView({
            sharedView: typeof Core.param('shared') != 'undefined',
            customerView: typeof Core.param('customer') != 'undefined' && isNaN(parseInt(Core.param('customer')))
        });
        if (Core.param('returnTo')) view.saveAction = Core.param('returnTo');

        view.editing = false;
        if (view.model.id != id) view.setModel(new JobOrder({id: id}));
        app.setMainView(view, Core.param('template') != undefined ? 'directory' : 'orders');
    },

    copyOrder: function(id) {
        debug.log('copy order', id);
        var view = new OrderDetailsView({
            sharedView: typeof Core.param('shared') != 'undefined',
            customerView: typeof Core.param('customer') != 'undefined' && isNaN(parseInt(Core.param('customer')))
        });
        if (Core.param('returnTo')) view.saveAction = Core.param('returnTo');

        view.editing = true;
        var template = new JobOrder();
        template.set(JSON.parse(sessionStorage['core_order_template']));
        var order = new JobOrder();
        order.setFromTemplate(template, null, {"copy":true});
        if (template.get('title'))
            order.set('title', template.get('title'));
        view.selectedTemplate = template;
        view.modelIsCopy = true;
        view.setModel(order);
        //Reset recurring intervals from template
        view.model.set('lastCreatedJobStartTime', null);
        if (view.model.get('jobSpecifications')){
            view.model.get('jobSpecifications').forEach(function(jobSpecification){
                if (jobSpecification && jobSpecification.recurringIntervals){
                    jobSpecification.recurringIntervals.forEach(function(recurringInterval){
                        recurringInterval.lastCreatedJobStartTime = null;
                    })
                }
            })
        }
        app.setMainView(view, 'orders');
    },

    orders: function () {
        debug.log('orders');
        var view = new OrderListNewView({scrolling: true});
        var hash = Core.param('hash');
        if (hash) this.navigate(hash, { trigger: true, replace: true});
        else view.fetchList('all');
        app.setMainView(view, 'orders', { wideContainer: true});
    },

    all: function () {
        debug.log('all');
        var view = new OrderListView({scrolling: true});
        view.selectList('all');
        app.setMainView(view, 'orders', { wideContainer: true});

    },

    mine: function () {
        debug.log('mine');
        var view = new OrderListView({scrolling: true});
        view.selectList('mine');
        app.setMainView(view, 'orders', { wideContainer: true});
    },

    pending: function () {
        debug.log('pending');
        var view = new OrderListView({scrolling: true});
        view.selectList('pending');
        app.setMainView(view, 'orders', { wideContainer: true});
    },

    templates: function () {
        debug.log('templates');
        var view = new OrderListView({scrolling: true});
        view.fetchList('templates');
        app.setMainView(view, 'orders', { wideContainer: true});
    }
})
